module.exports = __webpack_public_path__ + "img/img-02.986ad089.jpg";